import { render, staticRenderFns } from "./headPage.vue?vue&type=template&id=c2637a32&scoped=true"
import script from "./headPage.vue?vue&type=script&lang=js"
export * from "./headPage.vue?vue&type=script&lang=js"
import style0 from "./headPage.vue?vue&type=style&index=0&id=c2637a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2637a32",
  null
  
)

export default component.exports